import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const WHATSAPP_NUMBER = "6289525652283";

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);

export const buildWhatsAppUrl = (items, total, note = "") => {
  let text = "Halo Winselindo! Saya ingin memesan produk berikut:%0A%0A";
  items.forEach((it, i) => {
    text += `${i + 1}. ${it.name} (${it.brand})%0A`;
    text += `   Qty: ${it.qty} x ${formatIDR(it.price)} = ${formatIDR(
      it.price * it.qty
    )}%0A%0A`;
  });
  text += `*Total: ${formatIDR(total)}*%0A`;
  if (note) text += `%0ACatatan: ${note}%0A`;
  text += "%0AMohon informasi ketersediaan & pengiriman. Terima kasih!";
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};
